import axios from "axios";
import { baseUrl } from '../config/clientsConfig'

const CPManageService = {

    getPremissionList :(type)=>{
        return axios.get(`${baseUrl}/cpUser/getPermissionsList/${type}`)
    },
    updatePermissionStatus : (body) =>{
        return axios.post(`${baseUrl}/cpUser/permission`,body)
    },
    getMemberDetails : (id) =>{
        return axios.get(`${baseUrl}/cpUser/getUserInfo/${id}`)
        },
        getPermissionCount : ()=>{
            return axios.get(`${baseUrl}/cpUser/newPermission`)
        }
        ,getMemberList : ()=>{
            return axios.get(`${baseUrl}/cpUser/getUsers`)
        },
        getUserByLead: (userUid = "",next="",direction="",leadStatus = "" ) => {
          return axios.get(`${baseUrl}/cpLeads/byUser?userUid=${userUid}&next=${next}&direction=${direction}&status=${leadStatus}`);
        }
        ,
        getLeadList: (params = {}) => {
            const queryParams = new URLSearchParams();
          
            if (params.next) {
              queryParams.append("next", params.next);
              queryParams.append("direction", "next");
            } else if (params.previous) {
              queryParams.append("previous", params.previous);
              queryParams.append("direction", "previous"); 
            }
          
            const queryString = queryParams.toString();
            const url = `${baseUrl}/cpLeads${queryString ? `?${queryString}` : ""}`;
          
            return axios.get(url);
          },
          
        CPManagementDashboardCount : ()=>{
            return axios.get(`${baseUrl}/cpLead/count/web`)
            },
            CPLeadSearch : (body)=>{
              return axios.post(`${baseUrl}/cpLeads/search`,body)
            },
            CPAssignedLeads : (type,nextId,direction) => {
              return axios.get(`${baseUrl}/cpLeads/unassigned-cpLead?type=${type}&next=${nextId}&direction=${direction}`)
              },

              CPAssignMultipleLeads : (body) => {
                return axios.post(`${baseUrl}/cpLeads/assign`, body)
                },
                CPUserStatusChange : (body) => {
                  return axios.put(`${baseUrl}/cpUser/userDisable`, body)
                }
              

}

export default CPManageService;